<template>
  <div style="">
    <div v-for="(item, index) in list" class="news-item" @click="goDetail(item)">
      <div class="t-al-l" style="font-size: 14px;font-weight: bold;margin: 10px 0;">{{item.tit}}</div>
      <div style="font-size: 0;"><img :src="$common.polishingImg('/boot/bh_img.php?bh=' + item.bh)" style="width: 100%;"/></div>
      <div style="color: #7f7f7f;margin-top: 12px;margin-bottom: 24px;font-size: 12px;" class="t-al-l">
        <span class="in-bl-v-m t-al-l">作者：不难得</span> <span class="in-bl-v-m" style="margin: 0 12px;">{{item.lastsj}}</span> <img class="in-bl-v-m" src="../assets/images/eyes.png" /> <span class="in-bl-v-m">{{ item.djl }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import common from '../assets/js/common'
export default {
  data: function() {
    return {
      activeList: [],
      list: []
    }
  },
  props: {
    classifyid:{
      type: String,
      default: ''
    }
  },
  methods:{
    goDetail(item)
    {
      this.$router.push({path:'/new_detail', query: { id: item.id }})
    },
    initPage()
    {
      common.cusHttp(this,'/boot/news.php',{action:'type_list', 'type': this.classifyid }, 'get').then((res)=>{
        res = JSON.parse(res.data)
        if( res.status ) {
          this.list = res.data;
        }
      })
    }
  },
  mounted()
  {
    this.initPage()
  }
}
</script>

<style>
.hello {
  background-color: #ffe;
}

.news-item
{
  border-bottom:1px solid rgb(230, 230, 230) ;
}
</style>